import React from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

const BreakfastFormModal = ({
  show,
  editingId,
  form,
  properties,
  roomTypes,
  saving,
  formError,
  onChange,
  onSave,
  onClose,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => !saving && onClose()}
      centered
      scrollable
      size="lg"
    >
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="h5 mb-0 fw-bold">
          {editingId ? "Edit" : "Add"} Breakfast Configuration
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        <div className="row g-3">
          <Form.Group className="col-md-6">
            <Form.Label className="fw-semibold">
              Property <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              required
              value={form.intPropertyID}
              disabled={saving}
              onChange={(event) => {
                onChange("intPropertyID", event.target.value);
                onChange("intHotelRoomID", "");
              }}
            >
              <option value="">Select property</option>
              {properties.map((property) => (
                <option key={property.propertyId} value={property.propertyId}>
                  {property.propertyName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="col-md-6">
            <Form.Label className="fw-semibold">
              Room Type <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              required
              value={form.intHotelRoomID}
              disabled={saving || !form.intPropertyID}
              onChange={(event) =>
                onChange("intHotelRoomID", event.target.value)
              }
            >
              <option value="">Select room type</option>
              {roomTypes.map((room) => (
                <option key={room.hotelRoomId} value={room.hotelRoomId}>
                  {room.roomType}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="col-md-6">
            <Form.Label className="fw-semibold">
              Breakfast Charge (₹) <span className="text-danger">*</span>
            </Form.Label>
            <div className="input-group">
              <span className="input-group-text fw-bold bg-light">₹</span>
              <Form.Control
                type="number"
                min="0"
                step="0.01"
                placeholder="e.g. 250"
                required
                value={form.BreakfastCharge}
                disabled={saving}
                onChange={(event) =>
                  onChange("BreakfastCharge", event.target.value)
                }
              />
            </div>
            <Form.Text className="text-muted">Charge per room</Form.Text>
          </Form.Group>

          <Form.Group className="col-md-6">
            <Form.Label className="fw-semibold">
              Effective From <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              required
              type="date"
              value={form.dtmEffectiveFrom}
              disabled={saving}
              onChange={(event) =>
                onChange("dtmEffectiveFrom", event.target.value)
              }
            />
            <Form.Text className="text-muted">Effective Date</Form.Text>
          </Form.Group>

          <Form.Group className="col-12">
            <Form.Label className="fw-semibold mb-2">Status</Form.Label>
            <div
              role="button"
              tabIndex={0}
              onClick={() =>
                !saving && onChange("bitStatus", !form.bitStatus)
              }
              className={`d-flex align-items-center justify-content-between p-3 rounded-3 border ${
                form.bitStatus
                  ? "border-success bg-success bg-opacity-10"
                  : "border-danger bg-danger bg-opacity-10"
              }`}
              style={{
                cursor: saving ? "not-allowed" : "pointer",
                transition: "all 0.2s ease-in-out",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <span
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: form.bitStatus ? "#198754" : "#dc3545",
                    boxShadow: form.bitStatus
                      ? "0 0 10px #198754, 0 0 18px rgba(25, 135, 84, 0.6)"
                      : "0 0 10px #dc3545, 0 0 18px rgba(220, 53, 69, 0.6)",
                    display: "inline-block",
                  }}
                />
                <div>
                  <div
                    className={`fw-bold fs-6 ${
                      form.bitStatus ? "text-success" : "text-danger"
                    }`}
                  >
                    {form.bitStatus ? "Active" : "Inactive"}
                  </div>
                  <small className="text-muted">
                    {form.bitStatus
                      ? "Configuration is active and live for bookings"
                      : "Configuration is deactivated/inactive"}
                  </small>
                </div>
              </div>
              <Form.Check
                type="switch"
                id="modal-status-toggle"
                checked={form.bitStatus}
                disabled={saving}
                onChange={(event) =>
                  onChange("bitStatus", event.target.checked)
                }
                className="fs-4 mb-0"
                style={{ cursor: "pointer" }}
              />
            </div>
            <small className="text-muted d-block mt-2">
              <i className="fa fa-info-circle text-primary me-1"></i>
              Only one breakfast rate can be active per room type at a time. Setting this to Active will automatically disable any older active rate for this room type.
            </small>
          </Form.Group>
        </div>

        {formError && (
          <div className="alert alert-danger mt-3 mb-0 py-2">{formError}</div>
        )}
      </Modal.Body>

      <Modal.Footer className="bg-light d-flex justify-content-end gap-2 border-top">
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={onSave}
          disabled={saving}
          className="px-4 fw-semibold"
        >
          {saving && (
            <Spinner animation="border" size="sm" className="me-2" />
          )}
          {editingId ? "Update Configuration" : "Save Configuration"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BreakfastFormModal;
